<template>
  <div class="eu-basis_5_md">
    <div class="emd-form-group" data-testid="order-code">
      <div class="eu-display_flex">
        <label class="emd-label" data-testid="label">{{ $t("orderCode.label") }}</label>
          <emd-tippy
            id="orderCode"
            class="eu-ml_1"
            :type="'simple'"
            :position="'top'"
            :content="$t('orderCode.tippy')"
            data-testid="tippy"
          >
            <i class="uil uil-info-circle"></i>
          </emd-tippy>
      </div>
      <input
        class="emd-input"
        v-model="orderCode"
        data-testid="input"
      />
    </div>
  </div>
</template>

<script>
import { EmdTippy } from 'emerald-vue/src/components'
export default {
  name: 'OrderCode',
  components: {
    EmdTippy
  },
  data: () => ({
    orderCode: ''
  }),
  methods: {
    setOrderCodeValue (event) {
      this.$store.dispatch('SET_ORDER_CODE', event)
    }
  },
  watch: {
    orderCode: {
      handler: function () {
        this.setOrderCodeValue(this.orderCode)
      }
    }
  },
  beforeMount () {
    this.orderCode = this.$store.getters.orderCode
  }
}
</script>
